// extracted by mini-css-extract-plugin
module.exports = {"change-button":"_1NbVXiEatt3IPqCkQ3231M","change-button__icon":"_3BI18iWxshRNYTejVjnv1z"};